import {BackendURL} from '../../Constants/AppData'
import getMediaDownloadTokenMutation from './GetMediaDownloadTokenMutation'

// const fetchTimeout = (url, ms, { signal, ...options } = {}) => {
//     const controller = new AbortController();
//     const promise = fetch(url, { signal: controller.signal, ...options });
//     if (signal) signal.addEventListener("abort", () => controller.abort());
//     const timeout = setTimeout(() => controller.abort(), ms);
//     return promise.finally(() => clearTimeout(timeout));
// };

const getMediaDownloadToken = ( media_uuid, jwt_token, callback ) => {

    const controller = new AbortController();
    const timeoutId = setTimeout( () => controller.abort(), 10000 );


    return fetch(`${BackendURL}/media/${media_uuid}/get-download-token`, {
        signal: controller.signal,
        headers: {
            'content-type': 'application/json',
            authorization: `Bearer ${jwt_token}`
        },
        method: 'POST',
    })
        .then( response => {
        if ( !response.ok ) {
            return Promise.reject( response )
        }
        return response.json() // or return response.text()
    } )
        .then( response => {
            if ( response.status === 403 || response.status === 401 /*|| response.status === 500*/ ) {
                localStorage.clear();
                window.location.href = "/";
            }
            callback( response.token )
            clearTimeout( timeoutId );
        } )
        .catch( error => {
            if(error.name === "AbortError"){
                console.error("Timeout");
                callback( "AbortError" );
            } else {
                console.error( "Error fetching after 'getMediaDownloadToken': ", error )
            }
        } );
};

export default getMediaDownloadToken
